import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Programs, Products, Features, Feature, Flows, ProdLimit } from 'bff/models/product';
import { Inscats, Inscat, Codes, Activities, Activity, Bulletin } from 'bff/models/info';
import { InsType } from 'constants/enums/insType.enum';
import _ from 'lodash';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { FireProdLink, Links } from 'bff/models/link';
import { BulletinType } from 'constants/enums/bulletinType.enum';
import { ProdLimitId } from 'constants/enums/prodLimitId.enum';

/**
 * @description 取得住火險商品首頁初始化資料
 * @param programId 專案代碼
 */
const fetchInitSetting = async (programId:string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const programIdReq = commonService.getApiReqData({ PROGRAM_ID: programId || '' });
  const fireLmtReq = commonService.getApiReqData({ INS_TYPE_ID: InsType.Fire, LIMIT_ID: `${ProdLimitId.FRBCLMT},${ProdLimitId.FRPRODLMT}` });
  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchProgramByInsTypeId(programIdReq, reqConfig, InsType.Fire),
    apiService.fetchProductByInsTypeId(baseReq, reqConfig, InsType.Fire),
    apiService.fetchFeatureByInsTypeId(baseReq, reqConfig, InsType.Fire),
    apiService.fetchFlowByInsTypeId(baseReq, reqConfig, InsType.Fire),

    apiService.fetchProdLimit(fireLmtReq, reqConfig),
    apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, InsType.Fire),
    apiService.fetchLinkByCategory(baseReq, reqConfig, InsType.Fire),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.CREDITCARD_BANK),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI),

    apiService.fetchAnnounces(baseReq, reqConfig, BulletinType.InsType, InsType.Fire)
  ]).then(([
    inscatsRes, programsRes, productsRes, featuresRes, flowsRes,
    fireLmtRes, activitiesRes, serviceLinksRes, creditCardCodeRes, UICodeRes,
    bulletinRes]) => {
    const inscatsBaseRes:BaseRes<Inscats> = { ...inscatsRes };

    const inscatRes = _.find(inscatsBaseRes.TRANRS.INSURANCE_CATEGORY, (inscat:Inscat) => inscat.INS_TYPE_ID === InsType.Fire) as Inscat;
    const programsBaseRes:BaseRes<Programs> = { ...programsRes };
    const productsBaseRes:BaseRes<Products> = { ...productsRes };
    const featuresBaseRes:BaseRes<Features> = { ...featuresRes };
    const flowsBaseRes:BaseRes<Flows> = { ...flowsRes };

    const fireLmtBaseRes:BaseRes<ProdLimit> = { ...fireLmtRes };
    const activitiesBaseRes:BaseRes<Activities> = { ...activitiesRes };
    const serviceLinksBaseRes:BaseRes<Links<FireProdLink>> = { ...serviceLinksRes };
    const creditCardCodeBaseRes:BaseRes<Codes> = { ...creditCardCodeRes };
    const uiCodeBaseRes:BaseRes<Codes> = { ...UICodeRes };

    const bulletinBaseRes:BaseRes<Bulletin> = { ...bulletinRes };

    const res = {
      inscat: { ...inscatRes },
      programs: commonService.arrayTypeReturn(programsBaseRes.TRANRS.PROGRAMS),
      products: commonService.arrayTypeReturn(productsBaseRes.TRANRS.PRODUCT),
      features: featuresBaseRes.TRANRS.FEATURE ? [...featuresBaseRes.TRANRS.FEATURE.sort((first:Feature, second:Feature) => first.SHOW_ORDER - second.SHOW_ORDER)] : new Array(0),
      flows: commonService.arrayTypeReturn(flowsBaseRes.TRANRS.FLOWS),

      frbcLmt: [...fireLmtBaseRes.TRANRS.FRBCLMT],
      frprodLmt: [...fireLmtBaseRes.TRANRS.FRPRODLMT],
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first:Activity, second:Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      },
      serviceLinks: serviceLinksBaseRes.TRANRS.LINKS ? [...serviceLinksBaseRes.TRANRS.LINKS.I04] : new Array(0),
      creditCardCode: commonService.arrayTypeReturn(creditCardCodeBaseRes.TRANRS.CODES),

      uiCode: commonService.arrayTypeReturn(uiCodeBaseRes.TRANRS.CODES),
      bulletin: bulletinBaseRes.TRANRS.BULLETIN ? { ...bulletinBaseRes.TRANRS } : { BULLETIN: {} } as Bulletin
    };

    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
